<template lang="html">

<div class="upload-img">
      <el-upload
        class="upload-demo"
        ref="upload"
        accept=".mp4"
        limit="1"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :file-list="fileList"
        :on-exceed="handleExeccd"
        :on-remove="handleRemove">
        <el-button size="small" type="primary">
             <span>点击上传</span>
        </el-button>
        <div slot="tip" class="el-upload__tip">只能上传 mp4 文件，且不超过 100M</div>
      </el-upload>
</div>

</template>

<script>
import { getToken } from '@/utils/auth';
import { getFileToken,getViewKey,detFile } from '@/api/account';
export default {
    name:'fileUpload',
    props:['files','listType','limit'],
    data(){
        return{
            fileList: [],
            postDat:'',

            viewDat:'',
            fileMap:{},
            fileStore:[]
        }
    },
    watch:{
        files:function(e){
            if(this.fileList.length === 0 && e){
               var files = JSON.parse(e);
               this.fileList = files;
               this.fileStore = files;
            }
        }
    },
    methods:{
        beforeUpload:function(file){
            var pattern = /\.mp4$/;
            var isFile = pattern.test(file.name);

            var isLt500K = file.size / 1024 /1024 <= 100;

            if (!isLt500K) {
                this.$message.error('文件大小不能超过 100M !');
            }

            if(!isFile){
                this.$message.error('只能上传格式为 mp4 的文件');
            }

            if(isLt500K && isFile){
               return true;
            }else{
               return false;
            }
        },

        handleSuccess:function(res,file,fileList){
            fileList.forEach(item => {
                this.fileMap[item.uid] = item.id;
            });
            this.fileMap[file.uid] = this.postDat.key;
            this.flieStoreSet(fileList);
        },

        handleRemove:function(file,fileList){
            detFile({id:file.id || this.fileMap[file.uid],fileType:1});
            this.flieStoreSet(fileList);
        },

        handleExeccd:function(){
            this.$message.error('请删除已有视频文件后重新上传');
        },

        flieStoreSet:function(fileList){
            this.fileStore = [];
            fileList.forEach(item => {
                var file = {
                    name:item.name,
                    id:this.fileMap[item.uid]
                }
                this.fileStore.push(file);
            })
            this.$emit('fileChange',this.fileStore);
        }

    },
    mounted:function(){
             let vm = this;
             var userInfo = this.$store.getters.userInfo;

             this.$refs.upload.$refs['upload-inner'].uploadFiles = function(files){
                 let svm = vm.$refs.upload.$refs['upload-inner'];
                 if (svm.limit && svm.fileList.length + files.length > svm.limit) {
                   svm.onExceed && svm.onExceed(files, svm.fileList);
                   return;
                 }
                 let postFiles = Array.prototype.slice.call(files);
                 if (!svm.multiple) { postFiles = postFiles.slice(0, 1); }
                 if (postFiles.length === 0) { return; }


                 getFileToken({userId:userInfo.userId,fileType:1}).then(res => {
                      vm.postDat = res;
                      postFiles.forEach(rawFile => {
                        svm.onStart(rawFile);
                        rawFile.postUrl = vm.postDat.fileUploadUrl;
                        if (svm.autoUpload) svm.upload(rawFile);
                      });
                 });
             };

             this.$refs.upload.$refs['upload-inner'].post = function(rawFile){
                  const { uid } = rawFile;
                  let svm = vm.$refs.upload.$refs['upload-inner'];
                  let s = {
                      token:getToken(),
                      key:vm.postDat.key,
                      fileSize:rawFile.size
                  };
                      const options = {
                        headers: svm.headers,
                        withCredentials: this.withCredentials,
                        file: rawFile,
                        data: s,
                        filename: svm.name,
                        action: rawFile.postUrl,
                        onProgress: e => {
                          svm.onProgress(e, rawFile);
                        },
                        onSuccess: res => {
                          svm.onSuccess(res, rawFile);
                          delete this.reqs[uid];
                        },
                        onError: err => {
                          svm.onError(err, rawFile);
                          delete this.reqs[uid];
                        }
                      };
                      const req = svm.httpRequest(options);
                      svm.reqs[uid] = req;
                      if (req && req.then) {
                        req.then(options.onSuccess, options.onError);
                      }
             };
    },
    created:function(){
        getViewKey().then(res => {
            this.viewDat = {
                imagePreUrl:res.imagePreUrl,
                token:res.token
            }
        })
    }
}
</script>

<style lang="css" scoped>

.upload-img{
    width: 420px;
    padding-top: 2px;
}

.el-upload__tip{
    display: inline-block;
    margin-left: 12px;
}

.imgCard{
    width: 120px;
    height: 120px;
    border-radius: 6px;
    border:1px solid #F1F1F1;
    margin-top: 12px;
}

.imgCard .pgress{
   margin: 15px;
}

</style>



// WEBPACK FOOTER //
// mvUpload.vue?6f188328